import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { EntryButtonStyled as EntryButton } from './styles/CustomEntriesStyled';
import ExtraBalance from '../../ExtraBalance';
import useSegment from '../../../hooks/useSegment';

const ExtraBalanceEntry = ({
  baseComponent: EntryComponent,
  children,
  autoOpen,
  ...props
}) => {
  const { isPrepaid, isHybrid } = useSegment();

  if (!isPrepaid && !isHybrid && autoOpen) {
    navigate('/403');
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <EntryComponent {...props} onClick={() => {}}>
      <ExtraBalance
        showByDefault={autoOpen}
        activator={({ setShow }) => (
          <EntryButton onClick={() => setShow(true)}>{children}</EntryButton>
        )}
      />
    </EntryComponent>
  );
};

ExtraBalanceEntry.propTypes = {
  baseComponent: PropTypes.elementType.isRequired,
  children: PropTypes.node.isRequired,
  autoOpen: PropTypes.bool,
};

ExtraBalanceEntry.defaultProps = {
  autoOpen: false,
};

export default ExtraBalanceEntry;
